import styled from "styled-components";

export const Wrapper = styled.div`
    display:grid;
    grid-template-columns: 1fr;
`;